var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row-item" }, [
    !_vm.isOrderServiceColumnReadonly[_vm.columnToEdit]
      ? _c(
          "div",
          {
            staticClass: "d-flex justify-space-between align-center",
            staticStyle: { width: "100%" }
          },
          [
            _c("span", { staticStyle: { "text-align": "left" } }, [
              _vm._v(_vm._s(_vm.localValue))
            ]),
            _c(
              "v-icon",
              {
                staticClass: "d-flex justify-end ml-2",
                staticStyle: { "font-size": "1.4rem" },
                on: { click: _vm.enableEdit }
              },
              [_vm._v("\n      edit\n    ")]
            )
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass: "row-item d-flex justify-space-between align-center",
            staticStyle: { width: "100%" }
          },
          [
            _c("v-text-field", {
              staticClass: "pa-0",
              model: {
                value: _vm.localValue,
                callback: function($$v) {
                  _vm.localValue = $$v
                },
                expression: "localValue"
              }
            }),
            _c(
              "v-icon",
              {
                class: ["d-flex justify-end ml-3", { rotate: _vm.isLoading }],
                staticStyle: { "font-size": "1.4rem", "max-width": "19.65px" },
                on: { click: _vm.confirmEdit }
              },
              [
                _vm.isLoading
                  ? [_vm._v("\n        autorenew\n      ")]
                  : [_vm._v("\n        save\n      ")]
              ],
              2
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }